import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';

interface AdminGeneralSettingState {
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}
const defaultColumnList = [
  {
    name: 'settings_key',
    label_key: 'settings_key',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 1,
  },
  {
    name: 'settings_value',
    label_key: 'settings_value',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 2,
  },
  {
    name: 'created_at',
    label_key: 'created_at',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 3,
  },
];
const exportColumnList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));
const initialState: AdminGeneralSettingState = {
  filterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminGeneralSettingSlice = createSlice({
  name: 'adminGeneralSetting',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setGeneralSettingTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      state.tableColumnList = action.payload;
    },
  },
});

export const {
  setFilterData,
  resetFilterData,
  setReloadTableData,
  setGeneralSettingTableColumnList,
} = adminGeneralSettingSlice.actions;

export default adminGeneralSettingSlice.reducer;
